import PropTypes from 'prop-types';
import React from 'react';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import Report from '../../../common/components/Report';

const ReceptaclesInPredesNotInCarditReport = props => (
  <Report
    id={props.id}
    tabs={[
      {
        value: ReportDefinitions.RECEPTACLES_IN_PREDES_NOT_IN_CARDIT_SUMMARY.id,
        label: 'SUMMARY',
      },
      {
        value: ReportDefinitions.RECEPTACLES_IN_PREDES_NOT_IN_CARDIT_DETAILS.id,
        label: 'DETAILS',
        loadFromTable: true,
        loadFromTableMessage: 'app.warning.load.from.summary.report',
      },
    ]}
    {...props}
  />
);
export default ReceptaclesInPredesNotInCarditReport;

ReceptaclesInPredesNotInCarditReport.propTypes = {
  id: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
  changeTrafficMode: PropTypes.func,
};
